import { render } from "./OptionsPopup.vue?vue&type=template&id=28c32feb&scoped=true"
import script from "./OptionsPopup.vue?vue&type=script&lang=js"
export * from "./OptionsPopup.vue?vue&type=script&lang=js"

import "./OptionsPopup.vue?vue&type=style&index=0&id=28c32feb&scoped=true&lang=scss"

import exportComponent from "/builds/dobro/amway-calculator-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c32feb"]])

export default __exports__